
import Vue from "vue";
export default Vue.extend({
	props: {
		title: {
			type: String,
			required: true
		},
		startTime: {
			type: Date as () => any,
			required: true
		},
		endTime: Date as () => any,
		color: {
			type: String,
			required: true
		},
		location: String
	},
	computed: {
		dateString():string {
			let now = new Date();
			let begin = this.startTime.toLocaleDateString();
			if (now.toLocaleDateString() == begin) {
				begin = this.startTime.toLocaleTimeString();
			}
			if (!this.endTime) {
				return begin;
			}

			let end = this.endTime.toLocaleDateString();
			if (now.toLocaleDateString() == end) {
				end = this.endTime.toLocaleTimeString();
			}

			if (begin == end) {
				return begin;
			}
			return `${begin} - ${end}`;
		}
	}
});
